import React from 'react';
import PropTypes from 'prop-types';
import { ScrollAnimationsContext } from './ScrollAnimationsProvider';
import {
  textAnimationStyles,
  imageWrapperAnimationStyles,
  podImageAnimationStyles,
} from '../../helpers/withSmokersHelpers';
import { getStarterKitClassNames } from '../../helpers/starterKitClassNamesHelper';

export const WithSmokers = ({
  introStatement,
  statement1,
  statement2,
  statement3,
  pods,
  deviceImageUrl,
  podImageUrl,
}) => {
  const withSmokersTrigger = React.useRef(null);
  const withSmokersGapSceneTrigger = React.useRef(null);
  const pinElementRef = React.useRef(null);
  const {
    withSmokersScene,
    simpleScene,
    withSmokersGapScene,
    cleanScene,
    satisfyingScene,
  } = React.useContext(ScrollAnimationsContext);

  React.useEffect(() => {
    withSmokersScene.triggerElement(withSmokersTrigger.current);
    withSmokersGapScene
      .triggerElement(withSmokersGapSceneTrigger.current)
      .setPin(pinElementRef.current, { pushFollowers: false });
    return;
  }, [withSmokersGapScene, withSmokersScene]);

  // Necessary for scaling image using pixels rather than transforms
  const viewportWidth = window.innerWidth;
  const {
    withSmokersAnimationClasses,
    cleanAnimationClasses,
    simpleAnimationClasses,
    podImageClasses,
    satisfyingAnimationClasses,
    deviceImageClasses,
    satisfyingPodsAnimationClasses,
  } = getStarterKitClassNames({
    withSmokersScene,
    simpleScene,
    cleanScene,
    satisfyingScene,
  });

  return (
    <>
      <div id="withSmokersTrigger" ref={withSmokersTrigger} />
      <div
        ref={pinElementRef}
        id="with-smokers"
        className="starterKit-statements-wrapper"
        style={{ height: withSmokersScene.duration() }}
      >
        <div className="starterKit-statements">
          <div
            className={`starterKit-statement with-smokers ${withSmokersAnimationClasses}`}
            style={textAnimationStyles(withSmokersScene.progress())}
          >
            <div className="starterKit-statement__header">{introStatement}</div>
          </div>

          <div
            className={`starterKit-statement simple ${simpleAnimationClasses}`}
          >
            <div
              className="starterKit-statement__content"
              dangerouslySetInnerHTML={{ __html: statement1 }}
            />
          </div>

          <div
            className={`starterKit-statement clean ${cleanAnimationClasses}`}
          >
            <div
              className="starterKit-statement__content"
              dangerouslySetInnerHTML={{ __html: statement2 }}
            />
          </div>

          <div
            className={`starterKit-statement satisfying ${satisfyingAnimationClasses}`}
          >
            <div
              className="starterKit-statement__content"
              dangerouslySetInnerHTML={{ __html: statement3 }}
            />
          </div>
        </div>

        <div className="images-container">
          <div
            className={`satisfying-images-wrapper ${satisfyingPodsAnimationClasses}`}
          >
            <div className="satisfying-image-group satisfying-image-group-1 ">
              <div className={`juul-pod-flavor juul-pod-flavor__position-1`}>
                <img src={pods[0].imageUrl} />
                <div className="juul-pod-flavor__text">{pods[0].content}</div>
              </div>
              <div className={`juul-pod-flavor juul-pod-flavor__position-3`}>
                <img src={pods[2].imageUrl} />
                <div className="juul-pod-flavor__text">{pods[2].content}</div>
              </div>
            </div>
            <div className="satisfying-image-group satisfying-image-group-2">
              <div className={`juul-pod-flavor juul-pod-flavor__position-2`}>
                <img src={pods[1].imageUrl} />
                <div className="juul-pod-flavor__text">{pods[1].content}</div>
              </div>
              <div className={`juul-pod-flavor juul-pod-flavor__position-4`}>
                <img src={pods[3].imageUrl} />
                <div className="juul-pod-flavor__text">{pods[3].content}</div>
              </div>
            </div>
          </div>

          <div className="juul-pen-image-container">
            <div
              className={`juul-pod-and-pen-images-wrapper ${deviceImageClasses}`}
              style={imageWrapperAnimationStyles(
                withSmokersScene.progress(),
                simpleScene.progress(),
                cleanScene.progress(),
                viewportWidth
              )}
            >
              <img
                className={`juul-pod-image ${podImageClasses}`}
                src={podImageUrl}
                style={podImageAnimationStyles(simpleScene.progress())}
              />
              <img className="juul-pen-image" src={deviceImageUrl} />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div id="withSmokersGapSceneTrigger" ref={withSmokersGapSceneTrigger} />
        <div
          id="withSmokersGapScene"
          style={{ height: `${withSmokersGapScene.duration()}px` }}
        />
      </div>
    </>
  );
};

WithSmokers.propTypes = {
  introStatement: PropTypes.string.isRequired,
  statement1: PropTypes.string.isRequired,
  statement2: PropTypes.string.isRequired,
  statement3: PropTypes.string.isRequired,
  pods: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string,
      content: PropTypes.string,
    })
  ),
  deviceImageUrl: PropTypes.string.isRequired,
  podImageUrl: PropTypes.string.isRequired,
};
